import { CaseState } from '@debbie/common/dist/cases/index.js'
import { useMutation } from '@debbie/common/dist/util/hooks.js'
import * as reportsAPI from '@debbie/cortex/dist/api/insights.js'
import { selectedCreditorId } from '@debbie/cortex/dist/internal.js'
import { RootState } from '@debbie/cortex/dist/reducer.js'
import { Col, Row } from '@debbie/iris/dist/components/Grid/index.js'
import EmailLarge from '@debbie/iris/dist/components/Icons/EmailLarge.js'
import { Button, Modal, Panel } from '@debbie/iris/dist/components/index.js'
import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { styled } from 'styled-components'

const DefaultReporter = () => {
  const lang = useSelector((s: RootState) => s.lang)
  const currentLang = useSelector((s: RootState) => s.currentLang)

  const [billingCaseOverviewOpen, setBillingCaseOverviewOpen] = useState(false)
  const [exportStarted, setExportStarted] = useState(false)

  const orderReport = useMutation(
    () =>
      reportsAPI.requestCaseOverviewReport(
        [selectedCreditorId],
        currentLang,
        CaseState.ALL,
      ),
    {
      onSuccess: () => {
        setExportStarted(true)
      },
      onError: (error) => {
        console.error(error)
        alert('Error')
      },
    },
  )

  const toggleCaseOverviewModal = () => {
    setBillingCaseOverviewOpen(!billingCaseOverviewOpen)
    setExportStarted(false)
  }

  return (
    <Row>
      <Col width="3">
        <PanelStyled header={lang.insights.caseOverview}>
          <p>{lang.insights.caseOverviewDesc}</p>
          <Button
            size="small"
            theme="secondary"
            onClick={toggleCaseOverviewModal}
            block
          >
            {lang.insights.orderReport}
          </Button>
          {billingCaseOverviewOpen && (
            <Modal
              onToggle={toggleCaseOverviewModal}
              header={lang.insights.caseOverview}
              maxWidth="282px"
            >
              {exportStarted ? (
                <div>
                  <EmailLarge
                    style={{
                      width: '8em',
                      height: '8em',
                      margin: '0 auto',
                      display: 'block',
                    }}
                  />
                  <h3 style={{ textAlign: 'center' }}>
                    {lang.insights.reportOrdered}
                  </h3>
                  <p style={{ textAlign: 'center' }}>
                    {lang.insights.reportOrderedText}
                  </p>
                  <Button block onClick={toggleCaseOverviewModal}>
                    {lang.insights.reportOrderedCloseButton}
                  </Button>
                </div>
              ) : (
                <div>
                  <Button
                    block
                    loading={orderReport.isLoading}
                    size="small"
                    disabled={!selectedCreditorId}
                    onClick={() => orderReport.mutate()}
                  >
                    {lang.insights.orderReport}
                  </Button>
                </div>
              )}
            </Modal>
          )}
        </PanelStyled>
      </Col>
    </Row>
  )
}

export default DefaultReporter

const PanelStyled = styled(Panel)`
  .body > p {
    min-height: 60px;
    margin-top: 8px;
  }
`
